var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedStatusBar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5C0 7.01472 2.01472 5 4.5 5H17.5C19.9853 5 22 7.01472 22 9.5C22 11.9853 19.9853 14 17.5 14H4.5C2.01472 14 0 11.9853 0 9.5Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.5C0 7.01472 2.01472 5 4.5 5H12.5C14.9853 5 17 7.01472 17 9.5C17 11.9853 14.9853 14 12.5 14H4.5C2.01472 14 0 11.9853 0 9.5Z",
    fill: "#079D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedStatusBar);
export default __webpack_public_path__ + "static/media/CompletedStatusBar.50ed0529fee7e767633e7a80c720f55a.svg";
export { ForwardRef as ReactComponent };